import { render, staticRenderFns } from "./loaderComponent.vue?vue&type=template&id=641b01e6&scoped=true"
var script = {}
import style0 from "./loaderComponent.vue?vue&type=style&index=0&id=641b01e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b01e6",
  null
  
)

export default component.exports